<template>

    <div class="min-h-screen flex flex-col">

        <div class="text-base text-grey-darkest font-normal min-h-screen flex items-center w-full text-center" v-if="chaserInfo == null">
            <div class="flex-1 max-w-sm mx-auto">
                <h1><i class="fa fa-circle-notch fa-spin text-white"></i></h1>
            </div>
        </div>

        <div class="text-base text-grey-darkest font-normal min-h-screen flex items-center w-full" v-if="!authenticated && chaserInfo !== null && chaserInfo.length !== 0">
            <div class="flex-1 max-w-sm mx-auto">

                <div class="bg-white rounded shadow">
                    <div class="border-b py-8 font-bold text-black text-center text-xl tracking-widest uppercase">
                        {{ chaserInfo.name }}'s Feed
                    </div>

                    <div class="bg-grey-lightest px-10 py-10">

                        <div class="bg-red-lightest border border-red-light text-red-dark px-4 py-3 rounded relative mb-8" role="alert" v-if="error">
                            <strong class="font-bold">Whoops!</strong>
                            <p class="mt-4">Your credentials are not correct. Please try again.</p>
                        </div>

                        <div class="mb-6">
                            <p>Welcome to <strong>{{ chaserInfo.name }}'s</strong> live chaser feed. If you are a media organization working directly with the chaser, you can enter the password below that <strong>{{ chaserInfo.name }}</strong> gave you.</p>
                        </div>

                        <div class="mb-6">
                            <label class="block text-grey-darker text-sm font-bold mb-2" for="name">
                                Password
                            </label>
                            <input class="border w-full p-3 outline-none focus:border-blue-dark" v-bind:class="{'border-red': error}" name="password" type="password" placeholder="**************" v-model="password" required @keyup.enter="loginButtonClicked()">
                        </div>
                        <div class="flex">
                            <button class="bg-blue hover:bg-blue-dark w-full p-4 text-sm text-white uppercase font-bold tracking-wider" v-on:click="loginButtonClicked()">
                                <span v-if="!loggingIn">Log in</span>
                                <span v-if="loggingIn"><i class="fas fa-circle-notch fa-spin"></i> logging in...</span>
                            </button>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <div v-if="authenticated">
            <header class="z-20 bg-black">
                <div class="container mx-auto px-5" v-if="type !== 'skinny'">
                    <nav class="flex items-center justify-between flex-wrap py-5 px-5 md:px-0 w-full">
                        <div class="flex items-center flex-no-shrink text-white md:mr-6 content-center">
                            <h2>{{ chaserInfo.name }}</h2>
                        </div>

                        <div cclass="w-full block md:flex md:items-center md:w-auto">
                            <div class="flex">
                                <h4 class="text-white" v-if="networkInfo !== null">{{ networkInfo.identifier }}</h4>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>

            <div class="container mx-auto">
                <div class="embed-responsive embed-responsive-16by9">
                    <StreamPlayer :streamId="this.chaserInfo.stream_keys[0].stream_id" :watermark="false" :ads="false" class="embed-responsive-item" />
                </div>
                <div class="w-full h-12 bg-black px-5 flex items-center">
                    <h2 class="text-grey-lighter" v-if="chaserInfo.location !== undefined && chaserInfo.location !== null">{{ chaserInfo.location.location_text }}</h2>
                    <h2 class="text-grey-lighter" v-if="chaserInfo.location == undefined || chaserInfo.location == null  || chaserInfo.location.location_text == null">Location Unavailable</h2>
                </div>
                <div class="bg-grey-darker" style="height: 400px">
                    <div id="map" style="width: 100%; height: 100%;"></div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

    import * as Config from '@/config'

    import StreamPlayer from '@/components/Modules/StreamPlayer'
    import * as mapboxgl from 'mapbox-gl'

    export default {
        name: 'home',
        data() {
            return {
                chaserInfo: null,
                authenticated: false,
                loggingIn: false,
                password: '',
                error: false,
                map: null,
                networkInfo: null,
            }
        },
        components: {
            StreamPlayer
        },
        mounted() {
            this.getChaserInfo()
        },
        methods: {
            getChaserInfo() {
                this.$http.get(Config.apiPath + "/api/v1/chasers/" + this.$route.params.profile).then((response) => {
                    this.$set(this, 'chaserInfo', response.data);
                });
            },
            loginButtonClicked() {
                var _this = this
                this.loggingIn = true
                this.$http.post(Config.apiPath + "/api/v1/chasers/" + this.chaserInfo.id + "/media/attempt", {
                    password: this.password
                }).then((response) => {
                    if(response.data.status == true) {
                        _this.authenticated = true
                        _this.error = false
                        _this.networkInfo = response.data.networkInfo
                        setTimeout(function() {
                            _this.initMap();
                        }, 50);
                    } else {
                        _this.error = true
                    }
                    _this.loggingIn = false
                });
            },
            initMap() {
                this.map = new mapboxgl.Map({
                    container: 'map',
                    style: 'https://api.maptiler.com/maps/darkmatter/style.json?key=8KVvDOgSDi1o5zYn2AIX',
                    center: [this.chaserInfo.location.longitude, this.chaserInfo.location.latitude ],
                    zoom: 10,
                });
                var _this = this
                this.map.on('style.load', function() {
                    new mapboxgl.Marker()
                        .setLngLat([_this.chaserInfo.location.longitude, _this.chaserInfo.location.latitude ])
                        .addTo(_this.map);                   
                });
            }
        },
    }

</script>
